<template>
  <div>
    <b-form @submit.prevent="onSubmitForm">
      <b-row class="article-create-edit-form">
        <b-col cols="12">
          <b-card no-body class="px-2 pb-4 mb-1 container-card">
            <b-card-header>
              <span class="information-header">Information</span>
            </b-card-header>
            <b-row class="px-2">
              <b-col cols="5">
                <b-row>
                  <b-col cols="12">
                    <span>{{ "Status" }} </span>
                    <b-form-checkbox
                      v-model="formData.status"
                      field-value="true"
                      class="custom-control-success custom-toggle"
                      name="check-button"
                      switch
                    >
                      <span class="switch-icon-left toggle-text">{{
                        "Active"
                      }}</span>
                      <span class="switch-icon-right toggle-text">{{
                        "Inactive"
                      }}</span>
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="12" class="mt-1">
                    <b-form-group
                      :label="'Category Name (Th)'"
                      label-for="category-name"
                      class="required"
                    >
                      <b-form-input
                        id="category-name"
                        v-model="formData.category_name_th"
                        required
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" class="">
                    <b-form-group
                      :label="'Category Name (En)'"
                      label-for="category-name-en"
                    >
                      <b-form-input
                        id="category-name-en"
                        v-model="formData.category_name_en"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <label for="valid-from-date" class="required">
                      Valid From
                    </label>
                    <div class="d-flex">
                      <div class="p-relative mr-1 article-date-picker">
                        <calendar-picker-icon
                          class="icon-calendar bypass"
                          :class="validFrom.date ? 'date-selected-icon' : null"
                        />
                        <flat-pickr
                          :id="'valid-from-date'"
                          v-model="validFrom.date"
                          class="form-control bg-date"
                          :class="validFrom.date ? 'date-selected' : null"
                          :config="flatpickrDateConfig"
                          placeholder="Start Date"
                          required
                          autocomplete="off"
                          @on-open="onOpenValidFromDatePicker"
                          @on-change="onSelectValidFromDate"
                        />
                      </div>
                      <div class="p-relative article-date-picker">
                        <clock-picker-icon
                          class="icon-calendar date-picker-icon bypass"
                          :class="validFrom.time ? 'date-selected-icon' : null"
                        />
                        <flat-pickr
                          id="valid-from-time"
                          v-model="validFrom.time"
                          class="form-control bg-date"
                          :class="validFrom.time ? 'date-selected' : null"
                          :config="flatpickrTimeConfig"
                          :placeholder="'HH : mm'"
                          required
                          autocomplete="off"
                          @on-open="onOpenValidFromTimePicker"
                          @on-change="onSelectValidFromTimePicker"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="12" class="mt-1">
                    <label for="valid-from-to" class="required">
                      Valid Through
                    </label>
                    <div class="d-flex">
                      <div class="p-relative mr-1 article-date-picker">
                        <calendar-picker-icon
                          class="icon-calendar bypass"
                          :class="
                            validThrough.date ? 'date-selected-icon' : null
                          "
                        />
                        <flat-pickr
                          :id="'valid-to-date'"
                          v-model="validThrough.date"
                          class="form-control bg-date"
                          :class="validThrough.date ? 'date-selected' : null"
                          :config="flatpickrDateConfig"
                          placeholder="End Date"
                          required
                          autocomplete="off"
                        />
                      </div>
                      <div class="p-relative article-date-picker">
                        <clock-picker-icon
                          class="icon-calendar date-picker-icon bypass"
                          :class="
                            validThrough.time ? 'date-selected-icon' : null
                          "
                        />
                        <flat-pickr
                          id="valid-from-time"
                          v-model="validThrough.time"
                          class="form-control bg-date"
                          :class="validThrough.time ? 'date-selected' : null"
                          :config="flatpickrTimeConfig"
                          :placeholder="'HH : mm'"
                          required
                          autocomplete="off"
                          @on-open="onOpenValidThroughTimePicker"
                        />
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card no-body class="px-2 mb-1 pb-4 container-card">
            <b-card-header>
              <span class="information-header">Icon or Image</span>
            </b-card-header>
            <div class="row px-2">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label class="font-medium-5" for="active">
                      Icon (Active)
                    </label>
                    <image-uploader
                      :image-url="formData.category_image_active.url"
                      @onUpload="onUploadImageActive"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="font-medium-5" for="inactive">
                      Icon (Inactive)
                    </label>
                    <image-uploader
                      :image-url="formData.category_image_inactive.url"
                      @onUpload="onUploadImageInactive"
                    />
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mt-1 mb-2">
        <b-col
          cols="12"
          class="
                d-flex
                justify-content-center
                flex-wrap
              "
        >
          <cancel-button
            class="mr-1"
            @click.native="$router.push('/article/article/category')"
          />
          <save-button :type="'submit'" :loading="loading.createOrEdit" />
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>


<script>
import {
  BForm,
  BCard,
  BRow,
  BCol,
  BCardHeader,
  BFormInput,
  BFormGroup,
  BFormCheckbox,
  BSpinner,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import CalendarPickerIcon from '@/@core/components/svg/common/CalendarPicker.vue'
import ClockPickerIcon from '@/@core/components/svg/common/ClockPicker.vue'
import ImageUploader from '@core/components/image-uploader/ImageUploader.vue'
import SaveButton from '@/views/components/button/SaveButton.vue'
import CancelButton from '@/views/components/button//CancelButton.vue'

import useArticleCategoryForm from '../hooks/useArticleCategoryForm'

export default {
  components: {
    BForm,
    BCard,
    BRow,
    BCol,
    BCardHeader,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    flatPickr,
    vSelect,
    CalendarPickerIcon,
    ClockPickerIcon,
    ImageUploader,
    SaveButton,
    CancelButton,
  },
  props: {
    isEdit: { type: Boolean, default: false },
  },
  setup(props) {
    const {
      formData,
      loading,
      validFrom,
      validThrough,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      onUploadImageActive,
      onUploadImageInactive,
      onSubmitForm,
    } = useArticleCategoryForm(props)
    return {
      formData,
      loading,
      validFrom,
      validThrough,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      onUploadImageActive,
      onUploadImageInactive,
      onSubmitForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

<style scoped>
@import '~@/assets/css/override-styles/dynamic-fields.css';
@import '~@/assets/css/pages/data-management.css';
@import '~@/assets/css/pages/article/create-article.css';
</style>
